/**
 * Quick-action tiles for the voice assistant sheet. Each `commandId` must exist on
 * `VoiceCommandRegistryService` so navigation matches voice commands (no fake routes).
 */
export type AssistantQuickActionIcon =
  | 'dashboard'
  | 'classroom'
  | 'lesson'
  | 'assessments'
  | 'classPick'
  | 'progress';

export interface AssistantQuickActionTile {
  commandId: string;
  icon: AssistantQuickActionIcon;
  labelKey: string;
}

export const ASSISTANT_QUICK_ACTION_TILES: AssistantQuickActionTile[] = [
  {
    commandId: 'nav_dashboard',
    icon: 'dashboard',
    labelKey: 'voiceAssistant.quickActions.dashboard',
  },
  {
    commandId: 'nav_classroom',
    icon: 'classroom',
    labelKey: 'voiceAssistant.quickActions.classroom',
  },
  {
    commandId: 'nav_lesson_plan',
    icon: 'lesson',
    labelKey: 'voiceAssistant.quickActions.lessonPlans',
  },
  {
    commandId: 'nav_assessments',
    icon: 'assessments',
    labelKey: 'voiceAssistant.quickActions.assessments',
  },
  {
    commandId: 'nav_class_selection',
    icon: 'classPick',
    labelKey: 'voiceAssistant.quickActions.classSelection',
  },
  {
    commandId: 'nav_progress_overview',
    icon: 'progress',
    labelKey: 'voiceAssistant.quickActions.progressOverview',
  },
];
